var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.resolveLayoutVariant,{tag:"component"},[(!(_vm.not_found || _vm.forbidden))?_c('router-view'):(_vm.not_found)?_c('page-not-found'):(_vm.forbidden)?_c('page-forbidden'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }